
import Vue from 'vue'
import App from './App.vue'
import config from './config.js'

// import {version} from "vue";
// console.log('Vue version', version);

// base url global variable
Vue.prototype.$base_url = config.getConfig().baseurl

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

//Custom Added

// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);

// Release 2 (F10): $sanitizeHtml(value) cleans rich text shown with v-html
import { sanitizeHtml } from './util/sanitizeHtml';
Vue.prototype.$sanitizeHtml = sanitizeHtml;

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')
Vue.config.productionTip = false

import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

Vue.config.devtools = false;
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    acl,
    render: h => h(App)
}).$mount('#app')